import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Tv, Wifi, Sparkles, ArrowRight } from 'lucide-react';
import toast from 'react-hot-toast';
import { customerAPI } from '../../services/api';

// Dashboard card shown in place of a service hero when the customer doesn't have
// that service yet — "Interested? Request today" pings the admins on WhatsApp
// (POST /customers/me/service-interest), "View Plans" goes to the Plans page.
export default function ServiceInterestCard({ service }) {
  const [sending, setSending] = useState(false);
  const [sent, setSent] = useState(false);
  const isCatv = service === 'catv';
  const label = isCatv ? 'CableTV' : 'Broadband';
  const Icon = isCatv ? Tv : Wifi;
  const accent = isCatv ? '#7c3aed' : '#0284c7';
  const blurb = isCatv
    ? 'Crystal-clear channels, HD packs and regional favourites for the whole family.'
    : 'High-speed unlimited fiber internet for streaming, work and gaming.';

  const handleRequest = async () => {
    setSending(true);
    try {
      const { data } = await customerAPI.requestServiceInterest(service);
      toast.success(data.message || 'Request sent!');
      setSent(true);
    } catch (err) {
      toast.error(err.response?.data?.message || 'Failed to send request');
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="card" style={{ padding: '18px 20px', marginBottom: 20, border: `1.5px dashed ${accent}55` }}>
      <div style={{ display: 'flex', alignItems: 'flex-start', gap: 14 }}>
        <div style={{
          width: 46, height: 46, borderRadius: 14, flexShrink: 0, display: 'flex', alignItems: 'center', justifyContent: 'center',
          background: `${accent}14`,
        }}>
          <Icon size={22} color={accent} />
        </div>
        <div style={{ minWidth: 0, flex: 1 }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 6, flexWrap: 'wrap' }}>
            <span style={{ fontWeight: 800, fontSize: '1.05rem' }}>{label}</span>
            <span style={{
              display: 'inline-flex', alignItems: 'center', gap: 4, fontSize: '.64rem', fontWeight: 800,
              letterSpacing: '.05em', textTransform: 'uppercase', padding: '3px 9px', borderRadius: 99,
              background: `${accent}14`, color: accent,
            }}>
              <Sparkles size={10} /> New for you
            </span>
          </div>
          <p style={{ fontSize: '.83rem', color: 'var(--text-muted)', margin: '4px 0 0' }}>
            Interested in this service? Request today and go through our plans. {blurb}
          </p>
        </div>
      </div>

      <div style={{ display: 'flex', gap: 10, marginTop: 14 }}>
        <button
          onClick={handleRequest}
          disabled={sending || sent}
          style={{
            flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 6,
            padding: '10px 0', borderRadius: 12, border: 'none', cursor: sent ? 'default' : 'pointer',
            fontWeight: 700, fontSize: '.85rem', color: '#fff',
            background: sent ? '#16a34a' : accent, opacity: sending ? 0.7 : 1,
          }}>
          {sent ? '✓ Request Sent' : sending ? 'Sending…' : 'Request Today'}
        </button>
        <Link to={`/portal/plans?service=${service}`} style={{
          flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 6,
          padding: '10px 0', borderRadius: 12, textDecoration: 'none',
          fontWeight: 700, fontSize: '.85rem', color: accent, border: `1.5px solid ${accent}`,
        }}>
          View Plans <ArrowRight size={14} />
        </Link>
      </div>
    </div>
  );
}
